/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';

/**
 * 
 * @export
 * @interface GetSurveyEmployeeDto
 */
export interface GetSurveyEmployeeDto {
    /**
     * 
     * @type {string}
     * @memberof GetSurveyEmployeeDto
     */
    id: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetSurveyEmployeeDto
     */
    employee: GetEmployeeDto;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyEmployeeDto
     */
    employeeId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSurveyEmployeeDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetSurveyEmployeeDto interface.
 */
export function instanceOfGetSurveyEmployeeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "employee" in value;
    isInstance = isInstance && "employeeId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetSurveyEmployeeDtoFromJSON(json: any): GetSurveyEmployeeDto {
    return GetSurveyEmployeeDtoFromJSONTyped(json, false);
}

export function GetSurveyEmployeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSurveyEmployeeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'employee': GetEmployeeDtoFromJSON(json['employee']),
        'employeeId': json['employeeId'],
        'active': json['active'],
    };
}

export function GetSurveyEmployeeDtoToJSON(value?: GetSurveyEmployeeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'employee': GetEmployeeDtoToJSON(value.employee),
        'employeeId': value.employeeId,
        'active': value.active,
    };
}

